exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.lead-text-modal.modal-dialog {\n  max-width: 50%;\n}\n\ndiv.lead-text-preview {\n  cursor: default;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/lead-text/styles.css
// module id = 2798
// module chunks = 29